import * as React from "react";

import { ContactInquiries } from "../../../components";

export const ContactInquiriesContainer: React.FC = () => <ContactInquiries />;
